<template>
  <div class="token-amil" ref="tokenAmil">
    <div class="header">
      <p class="heading-lg">Informe seu token Amil</p>
      <span class="body-lg"
        >Token pode ser encontrado no aplicativo Amil Clientes, SMS ou Email.</span
      >
    </div>
    <div
      class="token-amil__card"
      v-for="(item, index) in tokenToFill"
      :key="`card-token-amil-${index}`"
    >
      <p class="heading-md">Token</p>
      <div class="token-amil__card-details">
        <p>
          senha ou solicitação: <span class="heading-sm">{{ item.healthInsurancePassword }}</span>
        </p>
      </div>
      <p class="overline">Insira o token</p>
      <VNewToken
        @tokenHasCompleted="changeTokenInput"
        :cardId="`card_${index}`"
        :ref="`card_${index}`"
        :verifyTokensBeforeSubmit="verifyTokensBeforeSubmit"
      />

      <div class="token-amil__buttons">
        <VNavButton
          class="mb-8"
          ref="tokenAmilSubmit"
          variant="primary"
          text="Continuar"
          @click.native="sendToken"
        />
        <VNavButton
          ref="tokenAmilNotFound"
          variant="tertiary"
          text="Não encontrei meu token"
          @click.native="showDrawer"
        />
      </div>
    </div>
    <DrawerBottom
      :open="openDrawer"
      @toggle="openDrawer = !openDrawer"
      @close="closeDrawer"
      v-if="openDrawer"
    >
      <template #content>
        <div class="drawer-content">
          <h3 class="drawer__title">Continuar sem token</h3>
          <span class="drawer__description"
            >Iremos te auxiliar em um de nossos guichês de atendimento.</span
          >
          <VButton text="Continuar" @click.native="skipToken" />
        </div>
      </template>
    </DrawerBottom>
  </div>
</template>

<script>
import VNewToken from '@/components/commons/VNewToken/VNewToken.vue';
import VNavButton from '@/components/commons/VNavButton.vue';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TokenAmil',
  components: {
    VNewToken,
    VNavButton,
    DrawerBottom,
  },
  data() {
    return {
      numberOfDigits: 6,
      tokenFieldsListModel: [],
      tokenModel: '',
      isTokenInvalidLocal: false,
      openDrawer: false,
      tokenToFill: [],
      verifyTokensBeforeSubmit: false,
    };
  },
  computed: {
    ...mapState({
      currentAdmissionPayment: ({ currentAdmission }) => currentAdmission.data.payments[0],
      currentAdmission: ({ currentAdmission }) => currentAdmission.data,
      amilTokensToValidate: ({ global }) => global.amilTokensToValidate,
    }),
  },
  created() {
    this.tokenToFill = this.amilTokensToValidate.map((tokenAmil) => ({
      healthInsurancePassword: this.formatPassword(tokenAmil),
      token: '',
    }));
  },
  mounted() {
    document.body.style.overflow = null;
  },
  methods: {
    ...mapActions([
      'postAuthorizationToken',
      'setHealthInsuranceAuthorizedNotEligible',
      'global/skipServiceDeskFlowFail',
    ]),
    formatPassword(password) {
      return `EX********${password.substring(password.length - 3)}`;
    },
    toggleDrawer() {
      const newDrawerStatus = !this.openDrawer;
      if (newDrawerStatus) {
        this.$refs.tokenAmil.scrollIntoView({ block: 'start', scrollBehavior: 'smooth' });
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = null;
      }
      this.openDrawer = newDrawerStatus;
      this.verifyTokensBeforeSubmit = false;
    },
    async sendToken() {
      const tokeens = this.getTokensAsIs();
      this.verifyTokensBeforeSubmit = true;
      const hasSomeTokenIncompleted = tokeens.find(
        (tokenAmil) => tokenAmil.replace('*', '').length !== 6
      );
      if (!hasSomeTokenIncompleted) {
        const params = this.amilTokensToValidate.map((tokenAmil, idx) => ({
          healthInsurancePassword: tokenAmil,
          token: tokeens[idx],
        }));
        this.postAuthorizationToken(params);
        return this.goNextStep('validation_loading');
      }
    },
    showDrawer() {
      this.toggleDrawer();
    },
    changeTokenInput(value) {
      const getTokenFocused = document.activeElement.id;
      const cardID = parseInt(getTokenFocused.split('_')[3]);
      if (value.length === 6) {
        this.tokenToFill[cardID].token = value;
        document.getElementById(getTokenFocused).blur();
      }
    },
    getTokensAsIs() {
      const tokens = [];
      for (let i = 0; i < this.tokenToFill.length; i++) {
        tokens[i] = '';
        for (let j = 0; j < this.numberOfDigits; j++) {
          tokens[i] += document.getElementById(`token_input_card_${i}_${j}`).value || '*';
        }
      }
      return tokens;
    },
    skipToken() {
      document.body.style.overflow = null;
      this.setHealthInsuranceAuthorizedNotEligible();
      this['global/skipServiceDeskFlowFail'](true);
      return this.goNextStep('validation_service_desk');
    },
    closeDrawer() {
      this.openDrawer = false;
      document.body.style.overflow = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.token-amil {
  padding-bottom: 100px;
  padding-top: 36px;
  overflow: scroll;

  &__card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 24px 24px;
    margin-bottom: 24px;
    gap: 16px;
    background: #ffffff;
    border: 1px solid rgba(22, 22, 22, 0.24);
    border-radius: 4px;
  }
  &__card-details {
    display: flex;
    flex-direction: column;
    text-align: left;
    border-left: 2px solid #0029bd;
    padding: 4px 8px;
    gap: 4px;
  }
  &__token-digits {
    display: flex;
    gap: 8px;
  }
  &__token-digit {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 40.65px;
    height: 43.35px;
    background: #ffffff;
  }

  &__buttons {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: inherit;
    margin: 0 auto;
    padding: 16px 12px;
    background-color: white;
  }
  .mb-8 {
    margin-bottom: 8px;
  }
  .token-input {
    width: 100%;
    height: 100%;
    border: none;
    font-size: 16px;
    line-height: 150%;
    border-radius: 4px;
    color: #363636;
  }
  .header {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 32px;
    margin-bottom: 24px;
  }
  .heading-lg {
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    color: #292929;
  }
  .heading-md {
    font-weight: 700;
    font-size: 20px;
    line-height: 120%;
    color: #161616;
  }
  .heading-sm {
    font-weight: 700;
    font-size: 16px;
    line-height: 150%;
    color: #363636;
  }
  .body-sm {
    font-size: 14px;
    line-height: 170%;
    color: #363636;
  }
  .overline {
    font-weight: 700;
    font-size: 12px;
    line-height: 133%;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #666666;
  }
}
.drawer__title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 24px;
}
.drawer__description {
  font-weight: 300;
  font-size: 16px;
  margin: 24px 0;
  color: #797c86;
  display: block;
}
</style>
